import { createFileRoute } from '@tanstack/react-router';

// relative imports
import ContactsPage from '../../components/contacts/ContactsPage';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/contacts')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: ContactsPage,
  staticData: {
    configPageId: 'contacts',
    meta: {
      title: 'Contacts | Ledgible',
    },
  },
});
